export type Tone = '' | 'good' | 'warn' | 'bad' | 'info' | 'accent';

/** Status code -> pill tone, as in the reference design's STATUS table. */
const TONES: Record<string, Tone> = {
  DRAFT: '', SUBMITTED: 'info', UNDER_VERIFICATION: 'info', PENDING_APPROVAL: 'warn', APPROVED: 'good', REJECTED: 'bad', RETURNED: 'warn',
  CONVERTED_TO_PO: 'accent', CLOSED: '', ISSUED: 'good', PARTIALLY_INVOICED: 'info', FULLY_INVOICED: 'accent', CANCELLED: '',
  RECEIVED: 'info', MISMATCH: 'bad', DUPLICATE: 'bad', VERIFIED: 'good', PAID: 'accent', RECONCILED: 'good', RELEASED: 'info', FAILED: 'bad',
  OPEN: 'info', PARTIALLY_RECEIVED: 'warn', OVERDUE: 'bad', POSTED: 'good', ACTIVE: 'good', INACTIVE: '', ARCHIVED: '', QUARANTINED: 'bad',
  CLOSING: 'warn', IN_PROGRESS: 'warn', MATCHED: 'good', SUGGESTED: 'info', UNMATCHED: 'warn', PARTIALLY_PAID: 'warn', DONE: 'good',
  QUEUED: 'info', RUNNING: 'info', UPCOMING: 'info', FILED: 'good', SUCCESS: 'good', PENDING: 'warn', WITHIN: 'good', FLAGGED: 'bad',
  EXPIRED: 'bad', LOCKED: 'bad', SENT: 'good', DEAD: 'bad', WAITING: '', SKIPPED: '', DEPOSITED: 'good', DEDUCTED: 'warn',
  PENDING_APPROVAL_VENDOR: 'warn', UNALLOCATED: 'warn', READY: 'good', ERROR: 'bad', SUPERSEDED: '',
};

/** Words that read better than a title-cased code. */
const LABELS: Record<string, string> = {
  CONVERTED_TO_PO: 'Converted to PO',
  FAILED_PASSWORD: 'Failed (wrong password)',
  FAILED_UNKNOWN_USER: 'Failed (unknown user)',
  LOCKED_OUT: 'Locked out',
  BLOCKED_INACTIVE: 'Blocked (inactive)',
  BLOCKED_EXPIRED: 'Blocked (access expired)',
  PARTIALLY_RECEIVED: 'Partially received',
  APPROVED_WITH_FLAG: 'Passed with flag',
};

export const toneOf = (code: string | null | undefined): Tone => (code && TONES[code]) || '';

export function statusLabel(code: string | null | undefined): string {
  if (!code) return '—';
  if (LABELS[code]) return LABELS[code];
  const words = code.toLowerCase().split('_');
  return words.map((w, i) => (i === 0 ? w[0].toUpperCase() + w.slice(1) : w)).join(' ');
}

export const ROLE_NAMES: Record<string, string> = {
  FA: 'Finance Admin', AE: 'Accounts Executive', FM: 'Finance Manager', DH: 'Department Head', GM: 'GM', CEO: 'CEO',
  IA: 'Internal Auditor', EA: 'External Auditor', SYSTEM: 'System',
};
